import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { IProject } from '@shared/model/projects';
import { IProjectConfig } from '@shared/model/projects';
import { isPlatformServer } from '@angular/common';

const PROJECTS_KEY = makeStateKey<IProject[]>('projects');
export const PROJECTS_COUNT_KEY = makeStateKey<number | null>('projects-count');

@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  private _baseUrl: string = `${environment.apiUrl}/projects`;

  constructor(
    private _http: HttpClient,
    private _transferState: TransferState,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {}

  getProjects(offset: number = 0): Observable<any> {
    const projects: IProject[] = this._transferState.get<IProject[]>(PROJECTS_KEY, []);
    this._transferState.remove(PROJECTS_KEY);
    if (projects.length && offset === 0) return of({ results: projects });

    return this._http
      .get(
        `${this._baseUrl}/projects/`,
        //  { params: { limit: 9, offset } }
      )
      .pipe(
        tap((data: any) => {
          if (isPlatformServer(this._platformId)) {
            this._transferState.set<IProject[]>(PROJECTS_KEY, [...projects, ...data.results]);
            this._transferState.set<number | null>(PROJECTS_COUNT_KEY, data.count);
          }
          this._transferState.set<number | null>(PROJECTS_COUNT_KEY, data.count); //TODO Remove
        }),
      );
  }

  getTariffs(): Observable<any> {
    return this._http.get(`${this._baseUrl}/tariff_plans/`);
  }

  createProject(projectConfig: Partial<IProjectConfig>): Observable<any> {
    return this._http.post(`${this._baseUrl}/projects/`, projectConfig);
  }

  deleteProject(id: number): Observable<any> {
    return this._http.delete(`${this._baseUrl}/projects/${id}/`);
  }

  copyProject(id: number): Observable<any> {
    return this._http.post(`${this._baseUrl}/project/copy/${id}/`, null);
  }

  /** метод получение значений для формирования параметров конфигурации проекта */
  getProjectsEnumChoicesRetrieve(): Observable<any> {
    return this._http.get(`${this._baseUrl}/enum-choices/`);
  }

  /** метод получение значенией списка "Источников финансирования" для формирования параметров конфигурации проекта */
  getProjectsFinancingSources(): Observable<any> {
    return this._http.get(`${this._baseUrl}/financing-sources/`);
  }

  // /** метод запроса текущей конфигруации проекта */
  createProjectConfig(id: string): Observable<any> {
    return this._http.put(`${this._baseUrl}/project-config/${id}/`, { mode: 'adapt' });
  }

  /** метод запроса текущей конфигруации проекта по id */
  getProjectConfig(id: number): Observable<any> {
    return this._http.get(`${this._baseUrl}/project-config/${id}/`);
  }

  /** метод обновления конфигруации проекта */
  updateProjectConfig(id: number, data: Partial<IProjectConfig>): Observable<any> {
    return this._http.put(`${this._baseUrl}/project-config/${id}/`, data);
  }

  /** метод обновления значения свойства в конфигруации проекта */
  patchProjectConfig(id: number, data: Partial<IProjectConfig>): Observable<any> {
    return this._http.patch(`${this._baseUrl}/project-config/${id}/`, data);
  }
  /** метод для раблокировки проектов при смене тарифа */
  unblockProjects(data: { ids: number[] }): Observable<any> {
    return this._http.post(`${this._baseUrl}/unblock-projects/`, data);
  }
}
